import UserAutoSelectSearch from "./user-autoselect-search";

export default UserAutoSelectSearch;